import { render, staticRenderFns } from "./SystemList.vue?vue&type=template&id=4a7f246e&lang=pug"
import script from "./SystemList.vue?vue&type=script&lang=js"
export * from "./SystemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7f246e')) {
      api.createRecord('4a7f246e', component.options)
    } else {
      api.reload('4a7f246e', component.options)
    }
    module.hot.accept("./SystemList.vue?vue&type=template&id=4a7f246e&lang=pug", function () {
      api.rerender('4a7f246e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/SystemList.vue"
export default component.exports